import "../Poolprogress.css";

export default function PoolProgress({ data }) {
  return (
    <div className="pool-container">
      <h3 className="pool-title">Pool Achievement Progress</h3>

      {data.length > 0 ? (
      data.map((item, index) => {
        const percentage = Math.min((item.current / item.goal) * 100, 100);

        return (
          <div key={index} className="pool-item">
            {/* Label */}
            <p className="pool-label">
              {item.label}: <span>{item.current} / {item.goal}</span>
            </p>

            {/* Progress Bar */}
            <div className="pool-new-prog">
            <span className="progress-text">{percentage.toFixed(1)}%</span>
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{
                  width: `${percentage}%`,
                  backgroundColor: item.color,
                }}
              >
              </div>
            </div>
            </div>
          </div>
        );
      })) : ("")}
    </div>
  );
}

  